import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7 1.953 5.66 6.137a.41.41 0 0 1-.41.3H1.176L4.62 8.927c.137.11.219.328.164.492l-1.203 3.938 3.145-2.434c.164-.137.382-.137.52 0l3.144 2.433-1.203-3.937c-.055-.164.027-.355.164-.465l3.445-2.488H8.75a.47.47 0 0 1-.437-.328zm-.71-.683C6.37.969 6.671.75 7 .75c.3 0 .602.219.684.52L9.05 5.563h4.21c.41 0 .739.328.739.738a.8.8 0 0 1-.3.601l-3.583 2.57 1.395 4.567a.577.577 0 0 1-.547.738.64.64 0 0 1-.356-.136L7 11.824l-3.637 2.817a.55.55 0 0 1-.355.109.556.556 0 0 1-.547-.71l1.394-4.567-3.554-2.57A.73.73 0 0 1 0 6.3c0-.41.3-.739.71-.739h4.212z"
    }, null, -1)
  ]))]))
}
export default { render: render }